module.exports = __webpack_public_path__ + "img/image.05a7f99f.svg";